export const hotComics = [
  {
    id: 'dahuang-yatou',
    slug: 'dahuang-yatou',
    title: '大黄丫头',
    author: '墨染青衣',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20young%20girl%20with%20warm%20yellow%20and%20orange%20color%20palette%2C%20soft%20watercolor%20style%2C%20dreamy%20atmosphere%2C%20Japanese%20manga%20inspired%20art%2C%20clean%20composition%2C%20light%20cream%20background%2C%20delicate%20linework%2C%20cute%20and%20elegant%20character%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    tags: ['无删减', '下拉式', '免费'],
    rating: 9.7,
    chapters: 186,
    status: '连载中',
    updateTime: '2026-07-02',
    description: '平凡少女大黄意外获得神秘力量，在奇幻世界中展开一段笑中带泪的冒险旅程。',
  },
  {
    id: 'xingchen-bianjie',
    slug: 'xingchen-bianjie',
    title: '星辰边界',
    author: '星海漫步',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20cover%20with%20sci-fi%20theme%2C%20starry%20space%20background%2C%20futuristic%20character%20in%20dark%20blue%20and%20silver%20tones%2C%20clean%20anime%20art%20style%2C%20light%20cream%20background%2C%20professional%20manga%20illustration%2C%20dreamy%20cosmic%20atmosphere&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '科幻',
    tags: ['热门', '高评分'],
    rating: 9.5,
    chapters: 132,
    status: '连载中',
    updateTime: '2026-07-01',
    description: '在遥远的未来，人类已经遍布银河系，一个少年在星辰之间寻找失落文明的秘密。',
  },
  {
    id: 'jianqi-jiuxiao',
    slug: 'jianqi-jiuxiao',
    title: '剑气九霄',
    author: '剑来工作室',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20martial%20arts%20manhua%20cover%2C%20swordsman%20with%20flowing%20robes%2C%20ancient%20Chinese%20landscape%20background%2C%20warm%20golden%20and%20crimson%20tones%2C%20elegant%20brushwork%20style%2C%20light%20cream%20background%2C%20professional%20illustration%2C%20epic%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '热血',
    tags: ['无删减', '下拉式'],
    rating: 9.6,
    chapters: 215,
    status: '连载中',
    updateTime: '2026-07-02',
    description: '少年剑客背负血海深仇，踏上修仙之路，以手中之剑斩破九霄。',
  },
  {
    id: 'anye-zhuizong',
    slug: 'anye-zhuizong',
    title: '暗夜追踪',
    author: '夜行者',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Chinese%20manhua%20cover%20with%20noir%20detective%20theme%2C%20dark%20alley%20atmosphere%2C%20shadowy%20figure%20in%20trench%20coat%2C%20moody%20lighting%2C%20clean%20manga%20art%20style%2C%20light%20cream%20background%2C%20suspenseful%20mood%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    tags: ['热门', '高评分'],
    rating: 9.3,
    chapters: 98,
    status: '连载中',
    updateTime: '2026-06-30',
    description: '城市暗处隐藏着无数秘密，私家侦探在迷局中抽丝剥茧，真相远比想象的更加残酷。',
  },
  {
    id: 'shiguang-lvxing',
    slug: 'shiguang-lvxing',
    title: '时光旅行者',
    author: '时光胶囊',
    cover: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Chinese%20manhua%20cover%20with%20time%20travel%20theme%2C%20vintage%20clock%20elements%2C%20character%20in%20retro%20clothing%2C%20warm%20sepia%20and%20gold%20tones%2C%20soft%20dreamy%20art%20style%2C%20light%20cream%20background%2C%20nostalgic%20atmosphere%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '奇幻',
    tags: ['新作', '下拉式'],
    rating: 9.1,
    chapters: 56,
    status: '连载中',
    updateTime: '2026-07-03',
    description: '一枚古老的怀表，开启了穿越时空的奇妙旅程，过去与未来在此交汇。',
  },
];

export const categories = [
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 1256, color: 'primary' },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', count: 983, color: 'primary' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 647, color: 'accent' },
  { name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', count: 532, color: 'accent' },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', count: 789, color: 'secondary' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 1123, color: 'secondary' },
  { name: '恐怖', slug: 'kongbu', icon: 'ri-ghost-line', count: 321, color: 'primary' },
  { name: '武侠', slug: 'wuxia', icon: 'ri-sword-line', count: 876, color: 'accent' },
  { name: '都市', slug: 'dushi', icon: 'ri-building-line', count: 654, color: 'secondary' },
  { name: '历史', slug: 'lishi', icon: 'ri-history-line', count: 432, color: 'primary' },
  { name: '体育', slug: 'tiyu', icon: 'ri-basketball-line', count: 298, color: 'accent' },
  { name: '美食', slug: 'meishi', icon: 'ri-restaurant-line', count: 187, color: 'secondary' },
];

export const featuredComics = [
  {
    id: 'dahuang-yatou',
    slug: 'dahuang-yatou',
    title: '大黄丫头',
    author: '墨染青衣',
    cover: 'https://readdy.ai/api/search-image?query=An%20artistic%20Chinese%20manhua%20illustration%2C%20young%20female%20protagonist%20with%20warm%20golden%20yellow%20tones%2C%20elegant%20watercolor%20style%2C%20soft%20dreamy%20background%2C%20high%20quality%20manga%20art%2C%20clean%20composition%2C%20beautiful%20character%20design%2C%20light%20atmosphere&width=600&height=800&seq=featured-cover-01&orientation=portrait',
    category: '恋爱',
    description: '平凡少女的非凡冒险，笑与泪交织的成长物语。',
    rating: 9.7,
  },
  {
    id: 'jianqi-jiuxiao',
    slug: 'jianqi-jiuxiao',
    title: '剑气九霄',
    author: '剑来工作室',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20martial%20arts%20manhua%20illustration%2C%20swordsman%20in%20ancient%20robes%2C%20mountain%20landscape%2C%20warm%20golden%20sunset%20tones%2C%20traditional%20ink%20painting%20influence%2C%20professional%20illustration%2C%20heroic%20atmosphere&width=600&height=800&seq=featured-cover-02&orientation=portrait',
    category: '热血',
    description: '手中三尺剑，斩尽天下不平事。',
    rating: 9.6,
  },
  {
    id: 'xingchen-bianjie',
    slug: 'xingchen-bianjie',
    title: '星辰边界',
    author: '星海漫步',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20sci-fi%20manhua%20illustration%2C%20cosmic%20explorer%20character%2C%20starry%20nebula%20background%2C%20deep%20blue%20and%20silver%20color%20scheme%2C%20clean%20anime%20art%20style%2C%20professional%20illustration%2C%20mysterious%20atmosphere&width=600&height=800&seq=featured-cover-03&orientation=portrait',
    category: '科幻',
    description: '在浩瀚星海中，寻找人类文明的答案。',
    rating: 9.5,
  },
];

export const latestUpdates = [
  { comicTitle: '大黄丫头', chapter: '第186话 新的开始', time: '2小时前', slug: 'dahuang-yatou' },
  { comicTitle: '剑气九霄', chapter: '第215话 决战巅峰', time: '5小时前', slug: 'jianqi-jiuxiao' },
  { comicTitle: '星辰边界', chapter: '第132话 黑洞之谜', time: '8小时前', slug: 'xingchen-bianjie' },
  { comicTitle: '暗夜追踪', chapter: '第98话 最后的线索', time: '12小时前', slug: 'anye-zhuizong' },
  { comicTitle: '时光旅行者', chapter: '第56话 时间的裂缝', time: '1天前', slug: 'shiguang-lvxing' },
  { comicTitle: '美食猎人', chapter: '第78话 传说中的食材', time: '1天前', slug: 'meishi-lieren' },
  { comicTitle: '校园物语', chapter: '第143话 毕业季', time: '2天前', slug: 'xiaoyuan-wuyu' },
  { comicTitle: '武林外传', chapter: '第89话 江湖再见', time: '2天前', slug: 'wulin-waizhuan' },
];

export const stats = [
  { value: 12800, suffix: '+', label: '漫画作品' },
  { value: 360, suffix: '万+', label: '注册用户' },
  { value: 99.2, suffix: '%', label: '用户好评率' },
];

export const testimonial = {
  quote: '叮当漫画网是我用过最棒的漫画阅读平台，无删减、高清画质、更新超快。大黄丫头是我最近的心头好，每一话都让人欲罢不能！',
  author: '漫画迷小王',
  role: '资深读者 · 3年老用户',
  avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20friendly%20portrait%20of%20a%20young%20Chinese%20person%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20clean%20professional%20headshot%20style%2C%20approachable%20and%20genuine%20expression&width=200&height=200&seq=testimonial-avatar-01&orientation=squarish',
};

export const siteInfo = {
  name: '叮当漫画网',
  slogan: '畅快追漫，尽在叮当',
  description: '叮当漫画网是国内领先的中文漫画在线阅读平台，致力于为漫画爱好者提供高质量、无删减的漫画阅读体验。我们拥有海量漫画资源，涵盖热血、恋爱、悬疑、科幻、奇幻、搞笑等多种类型，每日更新，画质高清，让您随时随地畅享漫画世界。',
  email: 'hello@homekleans.com',
  phone: '400-888-6666',
  address: '北京市朝阳区漫画大厦18层',
  social: {
    weibo: 'http://homekleans.com/',
    wechat: 'dingdangmanhua',
    qq: 'http://homekleans.com/dingdangmanhua',
  },
};

export const faqData = [
  {
    question: '叮当漫画网的漫画都是免费的吗？',
    answer: '是的！叮当漫画网上所有漫画内容完全免费，无需付费即可畅读。我们坚持为广大漫画爱好者提供无删减、高质量的免费阅读体验。',
  },
  {
    question: '什么是"无删减"漫画？',
    answer: '无删减漫画指的是完全按照原作内容呈现，不进行任何内容删减或修改的版本。叮当漫画网承诺所有漫画均为完整原版，让读者体验到作者最真实的创作意图。',
  },
  {
    question: '如何使用下拉式阅读？',
    answer: '在阅读页面，您只需向下滑动页面即可连续阅读，无需点击翻页按钮。下拉式阅读提供流畅自然的阅读体验，让您沉浸在漫画世界中不间断地追漫。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '热门漫画通常每日更新，其他作品根据作者更新频率，一般每周更新2-3话。您可以在漫画详情页查看具体的更新时间和更新计划。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！叮当漫画网采用响应式设计，完美适配手机、平板和电脑端。无论您使用什么设备，都能获得最佳的漫画阅读体验。',
  },
];